import { Routes, Route, Navigate } from 'react-router-dom';
import './admin.css';
import { AdminUserProvider, useAdminUser } from './AdminUserContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import StreamControl from './pages/StreamControl';
import Languages from './pages/Languages';
import AudioControl from './pages/AudioControl';
import Users from './pages/Users';

function RequireAuth({ children }) {
  const token = localStorage.getItem('admin_token');
  return token ? children : <Navigate to="/admin/login" replace />;
}

function RequireAdmin({ children }) {
  const { user } = useAdminUser();
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/admin/login" replace />;
  if (user && user.role !== 'admin') return <Navigate to="/admin/audio" replace />;
  return children;
}

function DefaultRedirect() {
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/admin/login" replace />;
  return <Navigate to="/admin/dashboard" replace />;
}

export default function AdminApp() {
  return (
    <AdminUserProvider>
      <Routes>
        <Route path="login" element={<div className="admin-root light"><Login /></div>} />
        <Route path="dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="stream" element={<RequireAdmin><StreamControl /></RequireAdmin>} />
        <Route path="languages" element={<RequireAdmin><Languages /></RequireAdmin>} />
        <Route path="audio" element={<RequireAuth><AudioControl /></RequireAuth>} />
        <Route path="users" element={<RequireAdmin><Users /></RequireAdmin>} />
        <Route index element={<DefaultRedirect />} />
        <Route path="*" element={<DefaultRedirect />} />
      </Routes>
    </AdminUserProvider>
  );
}
